import React, { useMemo } from 'react';
import { Tag } from '@fourthwall/components';
import * as S from './Podcast.styled';
export const Podcast = ({ status, artworkUrl, title, url, onClick }) => {
    const tag = useMemo(() => {
        if (status === 'Created') {
            return React.createElement(Tag, { appearance: "default", label: "Not synced" });
        }
        if (status === 'Syncing') {
            return React.createElement(Tag, { appearance: "default", label: "Syncing..." });
        }
        if (status === 'Errored') {
            return React.createElement(Tag, { appearance: "alert", label: "Sync failed" });
        }
        return React.createElement(Tag, { appearance: "success", label: "Synced" });
    }, [status]);
    return (React.createElement(S.Container, { onClick: onClick },
        React.createElement(S.Inner, null,
            React.createElement(S.Artwork, { src: artworkUrl }),
            React.createElement(S.Info, null,
                tag,
                React.createElement(S.TitleContainer, null,
                    React.createElement(S.Title, null, title),
                    url && React.createElement(S.Url, null, url))))));
};
